import { ApiUtil as api } from "@/utils/api.util.js";

export class UiLiciousService {

	static URL = process.env.API_URL + process.env.API_VER;

	static RESOURCE = "/uilicious/testing/logs/";

	static all(queryParams = {}) {

		return api.get(this.URL + this.RESOURCE, queryParams);
	
	}

}



// WEBPACK FOOTER //
// ./src/services/uilicious.service.js